// Mock market data for the XPTY chart.
// NOTE: This is placeholder visualization for development only.
// It must not be presented as live market data.

import { CONFIG } from "./config";

const base = CONFIG.price;

// Deterministic pseudo-random generator so the chart is stable per session.
function gen(seed, count, amplitude) {
  const pts = [];
  let v = base;
  let s = seed;
  for (let i = 0; i < count; i++) {
    s = (s * 9301 + 49297) % 233280;
    const rnd = s / 233280 - 0.5;
    v = v + rnd * amplitude;
    // gently pull back toward base
    v = v + (base - v) * 0.06;
    v = Math.max(base * 0.9, Math.min(base * 1.1, v));
    pts.push(Number(v.toFixed(4)));
  }
  // ensure the series ends exactly at the displayed price
  pts[pts.length - 1] = base;
  return pts;
}

export const CHART_DATA = {
  "24H": gen(11, 48, 0.006),
  "7D": gen(29, 56, 0.012),
  "30D": gen(53, 60, 0.02),
  "1Y": gen(97, 64, 0.03),
};

export const CHART_PERIODS = ["24H", "7D", "30D", "1Y"];
